import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { COOKIE_MFA } from '../../utils/index'
import Cookies from 'universal-cookie'
import logo from '../../assets/images/logo-animado-2.gif'
import { Input, Button, Alert } from 'antd'
import BunkeyAPI from '../../api/BunkeyAPI'
import './mfa.css'

export class MFA extends Component {

  constructor(props) {
    super(props)

    this.state = {
      security: '',
      error: false
    }
  }

  componentDidMount() {
    this.handleGetSecurityHash()
  }

  handleGetSecurityHash = () => {
    const { user } = this.props
    BunkeyAPI({
      url: `/get-security-hash`,
      data: {
        email: user.email
      },
      method: 'PUT',
    }).then(resp => {
      // console.log('handleGetSecurityHash.resp', resp)
    }).catch(err => {
      console.log('handleGetSecurityHash.err', err)
    })
  }

  handleValidateSecurityHash = () => {
    const { user, clienteSelected } = this.props
    const { security } = this.state
    BunkeyAPI({
      url: `/validate-security-hash`,
      data: {
        email: user.email,
        securityHash: security
      },
      method: 'PUT',
    }).then(resp => {
      if (resp.status === 200) {

        const cookies = new Cookies()
        let date = new Date()
        let cookieMfa = cookies.get(COOKIE_MFA) ? cookies.get(COOKIE_MFA) : []
        cookieMfa.push(clienteSelected._id)
        date = new Date(date.getTime() + 1000 * 60 * 60 * 24 * 30)
        cookies.set(COOKIE_MFA, cookieMfa, { path: '/', expires: date })

        this.props.history.push('/home')
      } else {
        this.setState({ error: true })
      }
    }).catch(err => {
      console.log('catch', err)
      this.setState({ error: true })
    })
  }

  handleOnInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { user, intl } = this.props
    const { security, error } = this.state
    const userFirstName = user.email
    const defaultAvatar = user.avatar ? user.avatar : '/images/icons/user-icon.svg'
    return (
      <div className="mfa-center-main">
        <div className="mfa-center-child">
          <div><img className="mfa-logo" src={logo} alt="Bunkey" /></div>
          <div className="mfa-text-center" style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: "mfa_title" })}</div>
          <div className="mfa-text-center">
            <img className="mfa-ico-user" src={defaultAvatar} alt="user" />
            <span>{userFirstName}</span>
          </div>
          <div className="mfa-text-info">
            {intl.formatMessage({ id: "mfa_info" })}
          </div>
          <div className="mfa-text-info">
            <Input placeholder="Contraseña dinámica" name="security" value={security} onChange={this.handleOnInputChange} />
          </div>
          {error && <div className="mfa-text-info">
            <Alert
              message={intl.formatMessage({ id: "mfa_err_title" })}
              description={intl.formatMessage({ id: "mfa_err_body" })}
              type="error"
            />
          </div>}
          <div>
            <Button type="primary" className="mfa-btn" onClick={this.handleValidateSecurityHash} >Aceptar</Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authUser.user,
    clienteSelected: state.client.data,
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(MFA)))